'use strict';

const Marionette = require('backbone.marionette');
const template = require('../templates/purchase.hbs');

const PurchaseView = Marionette.ItemView.extend({
  template,
  tagName:   'div',
  className: 'purchase-view',
});

module.exports = PurchaseView;
